import { Box, Flex } from "@chakra-ui/react";
import Header from '@/components/layout/Header';
import Lateral from '@/components/layout/Lateral';
import Footer from '@/components/layout/Footer';
import Container from '@/components/partials/Container';
import Advertising from '@/components/Advertising';
import Menu from './menu';
import advertisement from '@/lib/advertisement';

export default async function Main({ children, showLateralExtras }) {
  const { navmenu, colormenu } = Menu();
  const ads1 = await advertisement('super-topo');
  const ads2 = await advertisement('topo');
  const ads3 = await advertisement('lateral');

  return (
    <Box fontSize="mg">
      <Advertising ads={ads1.find(a => a.advPosition === 1)} padding="0" />

      <Header navmenu={navmenu} colormenu={colormenu} />

      <Container>
        <Box py="4">
          <Advertising ads={ads2.find(a => a.advPosition === 1)} />

          <Flex flexDirection={{ base: 'column', md: 'row' }} pt="4">
            <Box flex="1">
              { children }
            </Box>

            <Box ml="4" w="100%" maxW={{ base: '100%', md: '300px' }} display={{ base: 'none', md: 'block' }}>
              <Lateral ads={ads3} showLateralExtras={showLateralExtras} />
            </Box>
          </Flex>
        </Box>
      </Container>

      <Footer menu={[...navmenu, ...colormenu]} />
    </Box>
  )
}
